import { createSlice } from '@reduxjs/toolkit';

// Initial state of the search
const initialState = {
  selectedCategory: null, // Currently selected main category
  selectedSubcategory: null, // Currently selected subcategory
  queryKeyword: null, // The keyword to use for API search queries
  results: {}, // Cached results by unique key
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    selectCategory: (state, action) => {
      const { key, parentKey, queryKeyword } = action.payload;
      state.selectedCategory = parentKey || key; // Use parentKey if it exists, otherwise use key
      state.selectedSubcategory = parentKey ? key : null; // Subcategory is set only if parentKey exists
      state.queryKeyword = queryKeyword || null; // Store the query keyword for API searches
    },
    clearCategory: (state) => {
      state.selectedCategory = null;
      state.selectedSubcategory = null;
      state.queryKeyword = null;
    },
    setSelectedSubcategory: (state, action) => {
      state.selectedSubcategory = action.payload; // Store selected subcategory
    },
    clearSelectedSubcategory: (state) => {
      state.selectedSubcategory = null;
    },
    setResults: (state, action) => {
      const { cacheKey, data } = action.payload;
      if (state.results[cacheKey] !== data) {
        state.results[cacheKey] = data; // Only update if data has changed
      }
    },
    clearResults: (state) => {
      state.results = {}; // Clear all cached results
    },
  },
});

export const {
  selectCategory,
  clearCategory,
  setResults,
  setSelectedSubcategory,
  clearSelectedSubcategory,
  clearResults,
} = searchSlice.actions;

export default searchSlice.reducer;
